function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_x0020_1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.28 40.31c0.62,0.69 13.32,10.33 15.79,9.2 1.86,-1.69 1.83,-2.73 3.65,-4.5 7.57,0.77 12.62,7.54 22.53,4.91 1.91,2.43 -1.38,3.27 12.72,2.53 0.7,-4.62 0.42,-20.5 0.19,-26.03l-11.69 -0.04 -0.45 3.28 -10.49 -3.65c1.33,-3.14 4.24,-5.43 4.24,-8.75 -1.34,-2.15 -11.15,-8.55 -14,-9.8l-22.49 32.85z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M34.53 37.44c-5.48,0 -12.63,-2.15 -17.68,-1.29 -0.74,7.31 8.88,5.25 14.81,7.84 4.87,2.13 11.96,6.38 18,3.48 0.85,-16.62 1.83,-14.74 -5.34,-17.36 -2.2,-0.81 -4.26,-1.78 -6.7,-2.01 -1.92,4.32 -4.29,3.8 -3.09,9.34z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M10.39 39.79c1.24,1.56 9.6,7.11 11.46,7.75 1.47,-1.15 1.23,-1.05 1.97,-2.88 -2.64,-1.2 -4.89,-0.71 -7.17,-2.73 -1.54,-1.36 -3.16,-5 -1.05,-7.16 2.52,-2.58 2.11,0.65 5.61,-4.75 1.32,-2.06 2.69,-4.41 4.29,-5.91l5.47 3.42c-1.08,3.46 -3.82,4.81 -3.21,7.09 3.6,0.63 4.5,-2.1 7.91,-7.19 1.65,-2.46 5.01,-6.96 6.11,-9.48 -3.86,-2.43 -7.28,-5.28 -11.4,-7.61l-0.69 0.66c-0.31,0.35 -0.57,0.64 -0.87,1.05 -0.6,0.8 -0.79,1.18 -1.22,1.82l-17.21 25.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.8 38.89l22.52 -33.05c-7.54,-6.14 -7.31,-3.1 -17.5,12.18 -9.79,14.68 -13.67,16.89 -5.02,20.87z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FEFEFE",
  points: "52.17,50.26 54.73,50.32 57.78,50.31 60.08,50.18 60.08,28.71 52.17,28.49 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M2.14 35.03l1.77 0.63c1.79,-0.35 8.66,-11.59 10.23,-13.93 2.48,-3.69 8.63,-12.07 10.12,-15.53l-2.36 -1.21c-1.99,1.09 -8.45,11.63 -10.24,14.25 -2.1,3.07 -9.3,12.48 -9.52,15.79z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M21.6 33.92l2.68 0.24c1.49,-1.81 3.62,-4.22 3.39,-6.25l-0.95 -0.75c-1.63,0.46 -0.48,-0.87 -2.98,2.94 -0.82,1.26 -1.91,2.43 -2.14,3.82z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  x: 0.32,
  width: 64.44,
  height: 64.44
}));

var SvgCardPayment = function SvgCardPayment(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: "2em",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 64.76 64.44",
    role: "img",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCardPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CardPayment.0d408b0b.svg";
export { ForwardRef as ReactComponent };